"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ScenarioFormViewStyle = _interopRequireDefault(require("./../css/ScenarioFormViewStyle"));

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ScenarioFormView = function ScenarioFormView(_ref) {
  var _props$location$state;

  var props = _ref.props,
      scenario = _ref.scenario,
      viewData = _ref.viewData,
      currentSituations = _ref.currentSituations,
      setCurrentSituations = _ref.setCurrentSituations;

  var _useState = (0, _react.useState)(scenario.userScenarioDescription || ''),
      _useState2 = _slicedToArray(_useState, 2),
      scenarioValue = _useState2[0],
      setScenarioValue = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      submitDisabled = _useState4[0],
      setsubmitDisabled = _useState4[1];

  (0, _react.useEffect)(function () {
    scenario.userScenarioDescription = scenarioValue;

    if (scenarioValue.length > 2) {
      setsubmitDisabled('');
    } else {
      setsubmitDisabled('disabled');
    }
  }, [scenarioValue]);

  var saveScenario = function saveScenario(e) {
    if (submitDisabled != 'disabled') {
      var scenarios = currentSituations;

      if (!scenarios.includes(scenario)) {
        scenarios.push(scenario);
        setCurrentSituations(scenarios);
      }

      scenario.isSelected = true;
    }
  };

  var changeScenario = function changeScenario(e) {
    scenario.userScenarioDescription = '';
    scenario.isSelected = false;
    var scenarios = currentSituations;

    if (scenarios.includes(scenario)) {
      setCurrentSituations(scenarios.filter(function (scenario) {
        return scenario.isSelected;
      }));
    }

    typeof dataLayer !== 'undefined' ? dataLayer.push({
      'event': 'GAevent',
      'eventCategory': ' All Link & Button Clicks',
      'eventAction': 'Scenario change',
      'eventLabel': "".concat(scenario.title.html.html.replace(/<.*?>/g, '').trim())
    }) : null;
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, viewData.scenarioFormView.imageLabel !== 'undefined' && /*#__PURE__*/_react["default"].createElement(_ScenarioFormViewStyle["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "scenario-form-view ".concat(scenario.summaryImage ? '' : 'own-scenario')
  }, /*#__PURE__*/_react["default"].createElement("div", null, scenario.summaryImage && /*#__PURE__*/_react["default"].createElement("p", {
    className: "image-label",
    dangerouslySetInnerHTML: {
      __html: viewData.scenarioFormView.imageLabel.html.html
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "scenario-flex-wrapper"
  }, scenario.summaryImage && /*#__PURE__*/_react["default"].createElement("div", {
    className: "image"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: scenario.summaryImage.image.src,
    alt: scenario.summaryImage.image.alt
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "title"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: scenario.title.html.html
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "magenta-radius-button"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    onClick: changeScenario,
    to: {
      pathname: "overview",
      state: {
        reviewAnswersView: (_props$location$state = props.location.state) !== null && _props$location$state !== void 0 && _props$location$state.reviewAnswersView ? true : false
      }
    }
  }, viewData.scenarioFormView.changeButton.html.html))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    dangerouslySetInnerHTML: {
      __html: viewData.scenarioFormView.scenarioLabel.html.html
    },
    htmlFor: "user-description"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-input"
  }, /*#__PURE__*/_react["default"].createElement("textarea", {
    id: "user-description",
    name: "user-description",
    placeholder: viewData.scenarioFormView.scenarioPlaceholder.html.html.replace(/\s{2,}/g, ''),
    onChange: function onChange(e) {
      return setScenarioValue(e.currentTarget.value);
    },
    value: scenarioValue
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "saved",
    className: submitDisabled,
    onClick: saveScenario
  }, viewData.scenarioFormView.saveButton.html.html))))));
};

var _default = ScenarioFormView;
exports["default"] = _default;